import { initNewRelic } from './newrelic'
import { AgentOptions } from '@newrelic/browser-agent/loaders/agent'

declare global {
  interface Window {
    __NR_CONFIG__?: any;
  }
}

const config = window.__NR_CONFIG__;

if (config?.newRelic?.enableNewRelic) {

  const nrConfig = config.newRelic;

  const options: AgentOptions = {
    init: {
      soft_navigations: {
        enabled: nrConfig.spa_enabled,
        autoStart: nrConfig.autoStart
      },
      distributed_tracing: {
        enabled: nrConfig.distributed_tracing_enabled,
        cors_use_newrelic_header:
          nrConfig.distributed_tracing_cors_use_newrelic_header
      },
      privacy: {
        cookies_enabled: nrConfig.privacy_cookies_enabled
      },
      ajax: {
        deny_list: nrConfig.ajax_deny_list
      }
    },
    info: {
      beacon: nrConfig.info_beacon,
      errorBeacon: nrConfig.errorBeacon,
      licenseKey: nrConfig.licenseKey,
      applicationID: nrConfig.applicationID,
      sa: nrConfig.sa
    },
    loader_config: {
      accountID: nrConfig.accountID,
      trustKey: nrConfig.trustKey,
      agentID: nrConfig.agentID,
      licenseKey: nrConfig.licenseKey,
      applicationID: nrConfig.applicationID
    }
  };
  console.log('Initializing New Relic with options');
  initNewRelic(options);
}